module.exports = __webpack_public_path__ + "static/media/wine.5c12208f.jpg";